import type { Lead } from "../../../types/lead";

function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function LeadHero({ lead }: { lead: Lead }) {
  const c = lead.candidate;
  const photo = c.photoUrl;

  return (
    <div className="rounded-3xl border border-black/10 bg-white overflow-hidden">
      {/* Photo header */}
      <div className="h-40 bg-gradient-to-br from-rose/20 to-blush flex items-end justify-center relative">
        {photo ? (
          <img
            src={photo}
            alt={c.name}
            className="w-28 h-28 rounded-full object-cover border-4 border-white shadow-md -mb-14"
          />
        ) : (
          <div className="w-28 h-28 rounded-full bg-rose text-white text-3xl font-bold flex items-center justify-center border-4 border-white shadow-md -mb-14">
            {initials(c.name)}
          </div>
        )}
      </div>

      {/* Body */}
      <div className="px-6 pt-20 pb-6 text-center">
        <h2 className="text-2xl font-bold tracking-tight text-black">
          {c.name}
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-2 mt-3">
          {c.age && (
            <span className="text-[12px] bg-neutral-100 text-black px-3 py-1 rounded-full">
              {c.age} years
            </span>
          )}
          {c.occupation && (
            <span className="text-[12px] bg-neutral-100 text-black px-3 py-1 rounded-full">
              {c.occupation}
            </span>
          )}
        </div>

        {c.bio && (
          <p className="mt-4 text-[14px] text-muted leading-relaxed max-w-[420px] mx-auto">
            {c.bio}
          </p>
        )}

        {Array.isArray(c.interests) && c.interests.length > 0 && (
          <div className="mt-5 flex flex-wrap justify-center gap-2">
            {c.interests.map((i) => (
              <span
                key={i}
                className="text-[12px] bg-blush text-rose-dark border border-rose/20 px-3 py-1 rounded-full"
              >
                {i}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
